import { useQuery } from "@tanstack/react-query";

import { getRouteTimeline } from "../services/timeline";

export const useRouteTimeline = (params: {
  routeId: string;
  timelineLimit: number;
}) =>
  useQuery({
    queryFn: getRouteTimeline,
    queryKey: ["routes-timeline", params],
    retry: 2,
    staleTime: 30000,
  });
